export default __webpack_public_path__ + "static/media/camera-icon.21349fc0.svg";